var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product__item-grid"},_vm._l((_vm.vpsPlans),function(vpsPlan){return (_vm.vpsPlans)?_c('vps-plan',{key:vpsPlan.name,attrs:{"productPlan":vpsPlan,"domain":_vm.domain}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }